import { authFetch } from '@/services/apiClient'

// แบบประเมินก่อนสมัครงาน — server สุ่มข้อ/จับเวลา/ตรวจคะแนนเอง ไม่มีเฉลยส่งมาหน้าเว็บ
// คำตอบรับ/ส่งเป็น "ตำแหน่งตัวเลือกที่แสดง" (0..n-1) — server แปลงกลับเป็นคำตอบต้นฉบับเอง

interface ApiResponse<T> {
  success: boolean
  data?: T
  error?: string
  message?: string
}

export interface AssessmentQuestion {
  question_id: number
  section: string
  section_title: string
  question_text: string
  options: string[]
  selected: number | null
}

export interface SectionScore {
  code: string
  title: string
  score: number
  total: number
}

export interface AssessmentAttempt {
  attempt_id: number
  status: 'IN_PROGRESS' | 'SUBMITTED'
  started_at: string
  expires_at: string
  server_now: string
  submitted_at: string | null
  question_count: number
  questions?: AssessmentQuestion[]        // มีเฉพาะตอนกำลังทำ
  score?: number                          // มีเฉพาะหลังส่ง
  section_scores?: SectionScore[]
}

export interface PreAssessmentStatus {
  is_active: boolean
  required: boolean                       // true = ต้องทำแบบประเมินก่อนสมัครงาน
  title?: string
  time_limit_minutes?: number
  sections?: { code: string; title: string; pick_count: number }[]
  total_questions?: number
  attempt: AssessmentAttempt | null
}

async function parseJson<T>(res: Response): Promise<ApiResponse<T>> {
  try {
    return await res.json()
  } catch {
    return { success: false, error: 'เชื่อมต่อเซิร์ฟเวอร์ไม่สำเร็จ' }
  }
}

async function call<T>(path: string, init: RequestInit | undefined, fallback: string): Promise<T> {
  const res = await authFetch(path, init)
  const json = await parseJson<T>(res)
  if (!json.success || !json.data) throw new Error(json.error || json.message || fallback)
  return json.data
}

export const getPreAssessment = () =>
  call<PreAssessmentStatus>('/pre-assessment', undefined, 'โหลดแบบประเมินไม่สำเร็จ')

export const startPreAssessment = () =>
  call<AssessmentAttempt>('/pre-assessment/start', { method: 'POST' }, 'เริ่มแบบประเมินไม่สำเร็จ')

export const savePreAssessmentAnswers = (answers: Record<number, number | null>) =>
  call<AssessmentAttempt>('/pre-assessment/answers', { method: 'PUT', body: JSON.stringify({ answers }) },
    'บันทึกคำตอบไม่สำเร็จ')

export const submitPreAssessment = (answers?: Record<number, number | null>) =>
  call<AssessmentAttempt>('/pre-assessment/submit', { method: 'POST', body: JSON.stringify({ answers: answers ?? null }) },
    'ส่งแบบประเมินไม่สำเร็จ')

// เวลาที่เหลือ (ms) ณ ตอนได้ข้อมูล — คิดจาก expires_at กับ server_now (ทั้งคู่มาจาก server รูปแบบเดียวกัน)
// จึงไม่พึ่งนาฬิกา/timezone ของเครื่องผู้ใช้
export const remainingMsAtFetch = (a: AssessmentAttempt) =>
  Math.max(0, Date.parse(a.expires_at) - Date.parse(a.server_now))
